/* AB   HFB-046-MD-CART-AB */

(function() {
  var swiperInstance = null;
  var isInitializing = false;
  var debounceTimer = null;
  var retryCount = 0;
  var maxRetries = 20;
  var observerSetup = false;

  function initCrossSellNew() {
    if (isInitializing) return;

    var container = document.querySelector('.cross-sell-new__swiper');
    if (!container) {
      // Retry if container not found yet
      if (retryCount < maxRetries) {
        retryCount++;
        setTimeout(initCrossSellNew, 150);
      }
      return;
    }

    // Check if Swiper is already initialized and working
    if (swiperInstance && !swiperInstance.destroyed && container.classList.contains('swiper-initialized')) {
      return;
    }

    if (typeof window.Swiper === 'undefined') {
      if (retryCount < maxRetries) {
        retryCount++;
        setTimeout(initCrossSellNew, 150);
      }
      return;
    }

    isInitializing = true;
    retryCount = 0;

    // Destroy existing instance
    if (swiperInstance && !swiperInstance.destroyed) {
      try {
        swiperInstance.destroy(true, true);
      } catch (e) {}
      swiperInstance = null;
    }

    // Wait for DOM to settle
    requestAnimationFrame(function() {
      setTimeout(function() {
        var freshContainer = document.querySelector('.cross-sell-new__swiper');
        if (!freshContainer) {
          isInitializing = false;
          return;
        }

        try {
          swiperInstance = new Swiper(freshContainer, {
            slidesPerView: 2,
            breakpoints: {
              400: { slidesPerView: 2.4 },
            },
            spaceBetween: 16,
            navigation: {
              prevEl: '.cross-sell-new__arrow--prev',
              nextEl: '.cross-sell-new__arrow--next'
            },
            observer: true,
            observeParents: true,
            watchOverflow: true
          });
        } catch (e) {
          console.warn('Cross-sell Swiper init error:', e);
        }

        isInitializing = false;
      }, 50);
    });
  }

  function debouncedInit() {
    clearTimeout(debounceTimer);
    retryCount = 0;
    debounceTimer = setTimeout(initCrossSellNew, 200);
  }

  window.initCrossSellNew = initCrossSellNew;

  function setupObserver() {
    if (observerSetup) return;

    var cartBox = document.querySelector('.rc90-box');
    if (!cartBox) {
      setTimeout(setupObserver, 200);
      return;
    }

    observerSetup = true;

    var observer = new MutationObserver(function(mutations) {
      var hasSignificantChange = mutations.some(function(m) {
        return m.addedNodes.length > 0 || m.removedNodes.length > 0;
      });
      if (hasSignificantChange) {
        debouncedInit();
      }
    });

    observer.observe(cartBox, { childList: true, subtree: true });
  }

  // Multiple initialization triggers
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initCrossSellNew();
      setupObserver();
    });
  } else {
    initCrossSellNew();
    setupObserver();
  }

  window.addEventListener('load', function() {
    setTimeout(initCrossSellNew, 100);
  });

  // Hook into robust cart refresh
  var originalRefreshCart = null;
  function hookRobustCart() {
    if (window.robustCart && window.robustCart.refreshCart && !originalRefreshCart) {
      originalRefreshCart = window.robustCart.refreshCart.bind(window.robustCart);
      window.robustCart.refreshCart = async function() {
        await originalRefreshCart();
        setTimeout(debouncedInit, 100);
      };
    } else if (!window.robustCart) {
      setTimeout(hookRobustCart, 300);
    }
  }
  hookRobustCart();

  ['cart:updated', 'cart:refresh', 'cart-drawer:open', 'shopify:section:load']
    .forEach(function(evt) {
      document.addEventListener(evt, debouncedInit);
    });

  document.addEventListener('submit', function(e) {
    var form = e.target.closest('.cross-sell-new__form');
    if (!form) return;

    e.preventDefault();
    e.stopPropagation();

    var btn = form.querySelector('.cross-sell-new__add-btn');
    var variantInput = form.querySelector('input[name="id"]');
    if (!variantInput || !variantInput.value) return;

    var variantId = variantInput.value;

    if (btn) {
      btn.disabled = true;
      btn.textContent = '...';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
    })
    .then(function(res) { return res.json(); })
    .then(function() {
      if (btn) btn.textContent = 'ADDED';
      setTimeout(function() {
        if (window.robustCart && typeof window.robustCart.refreshCart === 'function') {
          window.robustCart.refreshCart();
        } else {
          window.location.reload();
        }
      }, 300);
    })
    .catch(function() {
      if (btn) {
        btn.disabled = false;
        btn.textContent = 'ADD';
      }
    });
  }, true);
})();
